export function relocationGetLocationsValidate(locations){
    return (
    Array.isArray(locations.data) &&
    locations.data.every(item =>
      typeof item === 'object' &&
      item !== null &&
      'id' in item &&
      'name' in item
    )
  )
}